import { createContext, Dispatch, useContext } from 'react';
import {
  PostShareStatus,
  SearchEveryoneSocialContent,
  SearchEveryoneSocialInput,
  SearchPostsFilter,
} from 'api';
import { SEARCH_LIMIT } from 'features/search/constants';
import moment from 'moment';

type SearchESAction =
  | { type: 'setSearchString'; value: string }
  | { type: 'setSearchTypes'; value: Array<SearchEveryoneSocialContent> }
  | { type: 'setPostFilter'; value: SearchPostsFilter }
  | { type: 'clearFilters' };

interface SearchContext {
  state: SearchEveryoneSocialInput;
  dispatch: Dispatch<SearchESAction>;
}

export const initialPostFilter: SearchPostsFilter = {
  content_types: [],
  share_status: PostShareStatus.AllPosts,
  is_branded: false,
  is_shareable: false,
  is_engageable: false,
  submitter_list: [],
  group_list: [],
  published_before: moment().endOf('days').unix(),
  published_after: moment().subtract(90, 'days').startOf('day').add(1, 'days').unix(),
  source: null,
};

export const initialSearchESState: SearchEveryoneSocialInput = {
  search_string: '',
  search_types: [SearchEveryoneSocialContent.Posts],
  cursor: null,
  limit: SEARCH_LIMIT,
  post_filter: initialPostFilter,
};

export const SearchEveryoneSocialContext = createContext<SearchContext>({
  state: initialSearchESState,
  dispatch: () => null,
});

export const searchEveryoneSocialReducer = (
  prevState: SearchEveryoneSocialInput,
  action: SearchESAction
) => {
  const updatePostFilter = (filters: SearchPostsFilter) => {
    return { ...prevState.post_filter, ...filters };
  };

  switch (action.type) {
    case 'setSearchString':
      return { ...prevState, search_string: action.value };
    case 'setSearchTypes':
      return { ...prevState, search_types: action.value };
    case 'setPostFilter':
      return { ...prevState, post_filter: updatePostFilter(action.value) };
    case 'clearFilters':
      return { ...prevState, post_filter: initialPostFilter };
  }
};

export const useSearchESContext = () => useContext(SearchEveryoneSocialContext);
